import Vue from "vue";

const state = Vue.observable({
    items: []
});

state.items = JSON.parse(localStorage.getItem("favourites")) || [];

export const addFavourite = (id) => {
    return new Promise((resolve) => {
        state.items.push(id);
        localStorage.setItem("favourites", JSON.stringify(state.items));
        resolve(state.items);
    });
};

export const removeFavourite = (id) => {
    return new Promise((resolve) => {
        const index = state.items.indexOf(id);
        state.items.splice(index, 1);
        localStorage.setItem("favourites", JSON.stringify(state.items));
        resolve(state.items);
    });
};

export default {
    items: state.items,
    add: addFavourite,
    remove: removeFavourite
};